module.exports = "/assets/data/e2055dfc7528e9ae35ee83f53c9c696e-SW1E.data.json";